
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.431 2.994l-1.198-.5v8.075l2.173-5.24a1.79 1.79 0 00-.975-2.335zM.993 6.303l4.436 10.686a1.797 1.797 0 001.618 1.127c.233 0 .474-.045.707-.143l6.59-2.727a1.805 1.805 0 001.1-1.601 2.048 2.048 0 00-.116-.725L10.857 2.234a1.747 1.747 0 00-1.619-1.118c-.232 0-.465.054-.688.134L1.968 3.978a1.783 1.783 0 00-.975 2.325zm14.442-3.398a1.789 1.789 0 00-1.788-1.789H12.35l3.085 7.458","fill":"#E4EEF7"}})])
          )
        }
      }
    